import type { PressureThreat } from "../scenes/battlefieldPressure.js";

const ICON_EDGE_PAD_Y = 2;

export interface PressureThreatIconLayoutInput {
  readonly railX: number;
  readonly railY: number;
  readonly railWidth: number;
  readonly railHeight: number;
  readonly iconSize: number;
}

export function shouldRenderPressureThreatIcon(threat: PressureThreat): boolean {
  return threat === "danger";
}

export function resolvePressureThreatIconPosition(input: PressureThreatIconLayoutInput): { x: number; y: number } {
  const half = input.iconSize / 2;
  const minLocalY = half + ICON_EDGE_PAD_Y;
  const maxLocalY = Math.max(minLocalY, input.railHeight - half - ICON_EDGE_PAD_Y);
  return {
    x: input.railX + input.railWidth / 2 + half + 4,
    y: input.railY + maxLocalY,
  };
}
